// Environment variable utility for cross-platform compatibility
// Works with both Vite (import.meta.env) and Node.js/CRA (process.env)

function getEnvVar(key: string, defaultValue?: string): string {
  // In Vite environment
  if (typeof import.meta !== 'undefined' && import.meta.env) {
    return import.meta.env[key] ?? defaultValue ?? '';
  }

  // In Node.js or legacy CRA environment
  if (typeof process !== 'undefined' && process.env) {
    return process.env[key] ?? defaultValue ?? '';
  }

  return defaultValue ?? '';
}

function isDevelopment(): boolean {
  const nodeEnv = getEnvVar('NODE_ENV') || getEnvVar('VITE_NODE_ENV');
  return nodeEnv === 'development';
}

function isProduction(): boolean {
  const nodeEnv = getEnvVar('NODE_ENV') || getEnvVar('VITE_NODE_ENV');
  return nodeEnv === 'production';
}

export { getEnvVar, isDevelopment, isProduction };
